// 导航菜单配置（与 Header.vue 中的 menuList 保持一致）
export const menuList = [
  {
    title: '首页',
    path: '/'
  },
  {
    title: '通知公告',
    cid: 1052,
    path: '/news',
  },
  {
    title: '招聘会',
    cid: 1045,
    path: '/open_affairs',
  },
  {
    title: '招人才',
    cid: 1037,
    path: '/party',
  },
  {
    title: '找工作',
    cid: 1031,
    path: '/discipline_inspection'
  },
  {
    title: '学技能',
    cid: 1026,
    path: '/tender'
  },
  {
    title: '政策指南',
    cid: 1052,
    path: '/news?type=8'
  },
  {
    title: '活动大厅',
    cid: 'contact_us',
    path: '/contact_us',
  }
]

// 根据路径查找菜单项
export function findMenuByPath(path, query = {}) {
  // 优先处理带查询参数的路径（如政策指南 /news?type=8）
  for (const menu of menuList) {
    if (menu.path.includes('?')) {
      const [menuPath, queryStr] = menu.path.split('?')
      if (path === menuPath) {
        const queryParams = new URLSearchParams(queryStr)
        let allParamsMatch = true
        for (const [key, value] of queryParams.entries()) {
          // 确保类型转换后比较（处理 '8' 和 8 的情况）
          const queryValue = query[key]
          if (queryValue === undefined || String(queryValue) !== String(value)) {
            allParamsMatch = false
            break
          }
        }
        if (allParamsMatch) {
          return menu
        }
      }
    }
  }
  
  // 如果没有匹配到带查询参数的菜单，再匹配不带查询参数的菜单
  for (const menu of menuList) {
    if (!menu.path.includes('?')) {
      if (menu.path === path || path.startsWith(menu.path + '/')) {
        return menu
      }
    }
  }
  
  return null
}

// 根据路径获取菜单标题
export function getMenuTitleByPath(path, query = {}) {
  const menu = findMenuByPath(path, query)
  return menu ? menu.title : null
}




// WEBPACK FOOTER //
// ./src/common/menuConfig.js